(function ($) {
  Drupal.behaviors.gc_check_balance = {
    attach: function attach(context) {
      return;

      //open flyout menu when clicked
      $(context).find(".gift-card__section__hero").each(function() {
        $('a[href^="https://wwws-pt1.givex.com"]').click(function(e) {
          e.preventDefault();
          var y = window.top.outerHeight / 2 + window.top.screenY - ( 799 / 2);
          var x = window.top.outerWidth / 2 + window.top.screenX - ( 540 / 2);
          window.open($(this).attr('href'),'title', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=540, height=799, top=${y}, left=${x}`);
          return false;
        });
      });
    }
  }
})(jQuery);
